'use client';

import { c as _c } from "react/compiler-runtime";
import { CountrySelectorDialog } from '@sprd/spreadshirt-shell';
import { useAtom } from 'jotai';
import { useLocale, useTranslations } from 'next-intl';
import { isLocale } from '@/i18n/domainConfig';
import { getUrlWithDomain } from '@/i18n/navigation';
import { countrySwitcherAtom } from '@/store/atoms';
import { COUNTRY_OPTIONS } from './CountryOptions';
export const ShopCountryDialog = () => {
  const $ = _c(16);
  const [open, setOpen] = useAtom(countrySwitcherAtom);
  const currentLocale = useLocale();
  const t = useTranslations();
  let t0;
  if ($[0] !== currentLocale) {
    t0 = locale => {
      if (!isLocale(locale)) {
        return;
      }
      const alternate = document.querySelector(`link[rel="alternate"][hreflang="${locale}"]`)?.getAttribute("href");
      window.location.href = alternate ?? (locale === currentLocale ? "/" : getUrlWithDomain({
        locale,
        href: "/"
      }));
    };
    $[0] = currentLocale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const applyCountry = t0;
  let t1;
  if ($[2] !== t) {
    t1 = t("shippingCalculator.chooseCountry");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("general.close");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("countrySwitcher.update");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== applyCountry || $[9] !== currentLocale || $[10] !== open || $[11] !== setOpen || $[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t4 = <CountrySelectorDialog open={open} onOpenChange={setOpen} countries={COUNTRY_OPTIONS} value={currentLocale} onChange={applyCountry} title={t1} closeLabel={t2} updateLabel={t3} />;
    $[8] = applyCountry;
    $[9] = currentLocale;
    $[10] = open;
    $[11] = setOpen;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};